/*
 * The Cognito user-pool password policy (infra/lib/auth-stack.ts
 * `passwordPolicy`: min 8, lowercase, uppercase, digit, no symbol required),
 * mirrored client-side so signup and reset show the rules up front instead of
 * letting the user discover them one rejected submit at a time. The server
 * stays authoritative — a policy change there still surfaces through the
 * `signup.weakPassword` error mapping.
 */

export type PasswordRuleId = 'length' | 'upper' | 'lower' | 'digit';

export const PASSWORD_RULES: ReadonlyArray<{ id: PasswordRuleId; test: (value: string) => boolean }> = [
  { id: 'length', test: (value) => value.length >= 8 },
  { id: 'upper', test: (value) => /[A-Z]/.test(value) },
  { id: 'lower', test: (value) => /[a-z]/.test(value) },
  { id: 'digit', test: (value) => /\d/.test(value) },
];

export function passwordChecks(value: string): Array<{ id: PasswordRuleId; met: boolean }> {
  return PASSWORD_RULES.map((rule) => ({ id: rule.id, met: rule.test(value) }));
}

export function meetsPasswordPolicy(value: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(value));
}
